import React from "react"
import BlockWrapper from "../technical/BlockWrapper"
import HeadlineEnhanced from "../molecules/HeadlineEnhanced"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import Button from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Button"
import {
  faArrowRight,
  faArrowUpRight,
} from "@fortawesome/sharp-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"

const SeriesOverviewBlock = ({ block }) => {
  return (
    <BlockWrapper block={{}} className="bg-siev-blue text-siev-white">
      <div>
        <HeadlineEnhanced
          headline={block.headline}
          subheadline={block.subheadline}
          headlineClass="text-siev-white"
          subheadlineClass="text-siev-orange"
        />
      </div>
      <div
        className={`flex flex-row flex-wrap pt-8 -mx-4 -mb-8 ${
          block.series_items?.length > 1 ? "justify-end" : ""
        }`}
      >
        {(block.text?.length > 0 || block.link_text?.length > 0) && (
          <div className="w-full h-auto px-4 sm:w-1/2 lg:w-1/3">
            <div className="flex-1 block w-full h-full mb-8">
              <Richtext text={block.text} />
              {block.buttons?.length > 0 &&
                block.buttons?.map((button, index) => (
                  <div className={index === 0 ? "mt-4" : ""} key={index}>
                    <Button
                      btnType="linkOrange"
                      className="-ml-5 w-fit"
                      link={button.link}
                    >
                      {button.link_text}
                      <FontAwesomeIcon
                        icon={faArrowUpRight}
                        size="1x"
                        className="w-5 h-5 mt-0.5 ml-2 -mb-0.5"
                      />
                    </Button>
                  </div>
                ))}
            </div>
          </div>
        )}
        {block.series_items?.length > 0 &&
          block.series_items?.map((item, index) => (
            <div
              className="w-full h-auto px-4 mb-8 sm:w-1/2 lg:w-1/3"
              key={index}
            >
              <div
                className="flex flex-col justify-between w-full h-full p-6 border border-siev-sand"
                link={item.link}
              >
                <div>
                  <Image
                    image={item.image}
                    aspectRatio="1by1"
                    className="w-full h-auto mb-4 aspect-square"
                  />
                  {item.headline?.length > 0 && (
                    <span className="block text-2xl font-bold">
                      {item.headline}
                    </span>
                  )}
                  {item.text?.length > 0 && (
                    <span className="block mt-2">{item.text}</span>
                  )}
                </div>
                {item.link_text?.length > 0 && (
                  <Button
                    className="flex justify-between w-full mt-6"
                    btnType="primaryOrange"
                    link={item.link}
                  >
                    {item.link_text}
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      size="1x"
                      className="w-5 h-5 mt-0.5 ml-2 -mb-0.5"
                    />
                  </Button>
                )}
              </div>
            </div>
          ))}
      </div>
    </BlockWrapper>
  )
}

export default SeriesOverviewBlock
